(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/drawselector/assets/javascripts/collections/drawselector.js') >= 0) return;  svs.modules.push('/components/sport/drawselector/assets/javascripts/collections/drawselector.js');

'use strict';

const Draw = svs.sport.drawselector.models.Draw;
const DrawselectorList = Backbone.Collection.extend({
  initialize() {},
  setData(draws, currentDraw) {
    draws.forEach(draw => {
      const newDraw = new Draw();
      newDraw.setData(draw, currentDraw);
      this.add(newDraw);
    });
  },
  getCurrentDraw() {
    return this.models.filter(model => model.get('isCurrentDraw'))[0];
  }
});
setGlobal('svs.sport.drawselector.collections.DrawselectorList', DrawselectorList);

 })(window);